/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import {
    TextField,
    TablePagination,
    TableRow,
    TableHead,
    TableContainer,
    TableCell,
    TableBody,
    Table,
    Paper,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    Grid,
    DialogContent,
    DialogContentText,
    DialogActions,
    Card,
} from '@material-ui/core';
import React, { useState, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import GetApp from '@material-ui/icons/GetApp';
// import EditIcon from '@material-ui/icons/Edit';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';

import { isNull } from 'lodash';
import Button from '../../components/button/MyButton';
import { cleanNumber, validateDocExtern, validarCPF, validarCNPJ } from '../../service/utils';
import Loading from '../../components/loading/Loading';
import api from '../../service/axios/api';
import FlashContext from '../../components/contexts/FlashContext';



const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    table: {
        minWidth: 1100,
    },
});


const StyledTableCell = withStyles(() => ({
    head: {
        // backgroundColor: theme.palette.common.black,
        // color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export default function LegalEntitytable({
    docs,
    page,
    setPage,
    itens,
    setItens,
    total,
    searchData,
    templateDownload
}) {
    const { t } = useTranslation();
    const classes = useStyles();
    // const [rows, setRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [menuOptions, setMenuOptions] = useState(null);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);

    const [Nome, setNome] = useState("");
    const [ID, setID] = useState("");
    const [CNPJ, setCNPJ] = useState("");
    const { notifySuccess, notifyError } = useContext(FlashContext);
    const [pixKey, setpixKey] = useState("")
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [verifyUser, setVerifyUser] = useState(false)


    const [selectedValue, setSelectedValue] = useState('');

    const options = [
        { value: 1, label: 'Telefone' },
        { value: 2, label: 'Email' },
        { value: 3, label: 'CPF/CNPJ' },
        { value: 4, label: 'Chave Aleatória' },
    ];

    const handleChange = (event) => {
        setSelectedValue(event.target.value);

    };

    function validarTelefone(telefone) {
        const regex = /^\d{10,11}$/; // Ex: 11999999999
        return regex.test(telefone);
    }

    function validarEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    function validarCPFCNPJ(cpfcnpj) {
        const num = cpfcnpj.replace(/[^\d]/g, '');
        if (num.length === 11) return validarCPF(num);
        if (num.length === 14) return validarCNPJ(num);
        return false;
    }

    function getTipoChavePix(valor) {
        switch (Number(valor)) {
            case 1:
                return 'Telefone';
            case 2:
                return 'Email';
            case 3:
                return 'CPF/CNPJ';
            case 4:
                return 'Chave Aleatória';
            default:
                return '';
        }
    }

    const handleMenu = (row, event) => {
        if (row.pix_key_type) {
            setSelectedValue(row.pix_key_type);
        }
        setNome(row.company_name)
        // setEmail(row.email)
        setCNPJ(row.cnpj)
        setpixKey(row.pix_key)
        setID(row.id)
        setAnchorEl(event.currentTarget)
        setVerifyUser(isVerifiedUser(row.is_verified))
    };

    const isVerifiedUser = (value) => {
        if (value === 1) {
            return true
        } else {
            return false
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        setOpenDialogEdit(true);
        handleClose();
    };

    const editUser = () => {
        api.legalEntities.editLegalIdentity(ID, Nome, CNPJ, selectedValue || '', pixKey || '')
            .then(() => {
                searchData()
                notifySuccess("Usuário Editado com sucesso!");
                setOpenDialogEdit(false)
                setPaymentLoading(false);
            })
            .catch(err => {
                if (err?.problems) {
                    err.problems?.forEach((p) => {
                        notifyError(p.msg)
                    })
                } else {
                    notifyError(err.message)
                }
            })
            .finally(() => setPaymentLoading(false));
    }

    // eslint-disable-next-line consistent-return
    const ConsultarCPF = async () => {
        setPaymentLoading(true);
        let isvalid = false
        switch (Number(selectedValue)) {
            case 1:
                if (!validarTelefone(pixKey)) {
                    notifyError('Telefone inválido. Deve conter 10 ou 11 dígitos numéricos.')

                } else {
                    isvalid = true
                }
                break;
            case 2:
                if (!validarEmail(pixKey)) {
                    notifyError('Email inválido.')
                } else {
                    isvalid = true
                }
                break;
            case 3:
                if (!validarCPFCNPJ(pixKey)) {
                    notifyError('Cnpj/CPF inválido.')
                } else {
                    isvalid = true
                }
                break;
            default:
                break
        }
        const doc = cleanNumber(CNPJ)
        if (isvalid) {
            if (validarCNPJ(doc)) {
                editUser()
            } else {
                notifyError(t('newOrder.cardVinc.cnpjError'));
            }
        }
        setPaymentLoading(false)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setItens(event.target.value);
    };
    return (
        <>
            <Paper className={classes.root} style={{ marginTop: "45px" }}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Nome da Companhia</StyledTableCell>
                                <StyledTableCell>CNPJ</StyledTableCell>
                                <StyledTableCell>Tipo Pix</StyledTableCell>
                                <StyledTableCell style={{ justifyContent: 'end', display: 'flex', gap: 10 }}> Chave Pix <GetApp onClick={templateDownload} style={{ cursor: 'pointer' }} /></StyledTableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {docs?.map((row, i) => {
                                return (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <StyledTableRow key={i}>
                                        <StyledTableCell>{row.cnpj}</StyledTableCell>
                                        <StyledTableCell>{row.company_name}</StyledTableCell>
                                        <StyledTableCell>{getTipoChavePix(row.pix_key_type)}</StyledTableCell>
                                        <StyledTableCell style={{ justifyContent: 'end', display: 'flex', gap: 10 }}>
                                            {row.pix_key}
                                            <MoreVertIcon
                                                onClick={e => handleMenu(row, e)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
                    component="div"
                    count={total}
                    rowsPerPage={itens}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                <Menu
                    id="menu-appbar"
                    style={{ borderRadius: '25px' }}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem className={classes.textNotification} onClick={handleEdit}>
                        Editar Pessoa Jurídica
                    </MenuItem>
                </Menu>
            </Paper>
            <Dialog
                onClose={() => setOpenDialogEdit(false)}
                open={openDialogEdit}
                fullWidth
                maxWidth="sm"
            >
                <Loading open={paymentLoading} msg="Editando pessoa jurídica..." />
                <DialogTitle id="simple-dialog-title">
                    <Grid
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Grid>Editar</Grid>
                        <Grid>{menuOptions && menuOptions.nf && menuOptions.nf}</Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* {verifyUser === true ? (
                            <Grid style={{
                                display: "block",
                                margin: "20px",

                            }}>
                                <p style={{ marginTop: "5px", }}>:</p>
                                <TextField
                                    color="secondary"
                                    onChange={(event) => setpixKey(event.target.value)}
                                    defaultValue={pixKey}
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                />
                            </Grid>

                        ) : ( */}
                        <Grid container xs={12} style={{ width: "100%" }}>
                            <div style={{ textAlign: 'center', marginBottom: '10px', border: '4px dashed #dfe622', padding: '5px' }}><span>ATENÇÃO</span><br />Ao realizar a atualização deste registro iremos fazer uma consulta na base da Serpro e isso irá gerar <span style={{ color: 'red' }}>custos operacionais para a Element</span>!</div>

                            <Grid style={{
                                display: "block",
                                width: "63%",
                                marginRight: "10px",
                            }}>
                                <p>Nome da empresa:</p>
                                <TextField
                                    color="secondary"
                                    onChange={(event) => setNome(event.target.value)}
                                    defaultValue={Nome}
                                    width="400px"
                                    fullWidth
                                    size="small"
                                    style={{ maxHeight: 10, minWidth: 260 }}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid style={{
                                width: "35%",
                                display: "block",

                            }}>

                                <p>CNPJ:</p>
                                <TextField
                                    color="secondary"
                                    onChange={(event) => setCNPJ(event.target.value)}
                                    defaultValue={CNPJ}
                                    size="small"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid container spacing={2} style={{ marginTop: "20px" }}>
                                <Grid item xs={6}>
                                    <p style={{ marginBottom: "8px" }}>Chave Pix:</p>
                                    <TextField
                                        color="secondary"
                                        onChange={(event) => setpixKey(event.target.value)}
                                        defaultValue={pixKey}
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <p style={{ marginBottom: "2px" }}>Tipo da chave Pix:</p>
                                    <select
                                        id="pixType"
                                        value={selectedValue}
                                        onChange={handleChange}
                                        style={{
                                            width: "100%",
                                            padding: '10px 13px',
                                            fontSize: '16px',
                                            borderRadius: '6px',
                                            border: '1px solid #ccc',
                                            outline: 'none',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <option value="" disabled>
                                            Selecione uma opção
                                        </option>
                                        {options.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* )} */}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <h6
                        style={{
                            cursor: 'pointer',
                            color: '#657588',
                            fontWeight: 'bold',
                            fontFamily: 'Open Sans',
                            marginTop: 5,
                        }}
                        onClick={() => setOpenDialogEdit(false)}
                    >
                        {t('OrderDetails.completeCancelBtn')}
                    </h6>
                    <Button
                        style={{ height: 40 }}
                        onClick={ConsultarCPF}
                        color="primary"
                        variant="contained"
                        label="Editar"
                    />
                </DialogActions>
            </Dialog >

        </>
    );
}
